import Logger from 'core/Logger';
import { SortDirection } from 'core/sorting';
export default (sortBy, sort) => {
    Logger.trace('single - update sortBy', sortBy, sort);
    return sort.direction === SortDirection.None ? [] : [sort];
};
